import { BankGlPreset } from "../../domain/entities/BankGlPickerEntity";
import { AccountTreeResultEntity } from "../../domain/entities/AccountTreeEntity";
import { fetchBankGlTree, FetchBankGlTreeOptions } from "../api/bankGlTreeApi";
import { AccountTreeMapper } from "../mappers/AccountTreeMapper";

export class BankGlTreeRepositoryImpl {
  async fetchTreeSummary(
    preset: BankGlPreset,
    selectedAccountId?: string,
    bankAccountId?: string,
  ): Promise<AccountTreeResultEntity> {
    return this.fetchTree({ preset, selectedAccountId, bankAccountId });
  }

  async fetchTreeForType(
    preset: BankGlPreset,
    accountType: string,
    selectedAccountId?: string,
    bankAccountId?: string,
  ): Promise<AccountTreeResultEntity> {
    return this.fetchTree({
      preset,
      accountType,
      selectedAccountId,
      bankAccountId,
    });
  }

  async fetchTreeSearch(
    preset: BankGlPreset,
    search: string,
    limit?: number,
    offset?: number,
    bankAccountId?: string,
  ): Promise<AccountTreeResultEntity> {
    return this.fetchTree({
      preset,
      search,
      limit,
      offset,
      bankAccountId,
    });
  }

  private async fetchTree(
    options: FetchBankGlTreeOptions,
  ): Promise<AccountTreeResultEntity> {
    try {
      const response = await fetchBankGlTree(options);
      return AccountTreeMapper.toResultEntity(response);
    } catch (error: unknown) {
      console.error("Error in BankGlTreeRepository:", error);
      throw error;
    }
  }
}

export const bankGlTreeRepository = new BankGlTreeRepositoryImpl();
